<div [formGroup]="customPagesProfileFormGroup" class="wrapper-cards">
  <div class="row">
    <div class="title-perso">
      <div class="title-buttons">
        <h4>{{ (isCreation ? 'ErrorHandler.create' : 'ErrorHandler.modify') | translate }}</h4>
        <div class="btn-container">
          @if (noTemplateActivated) {
          <span class="text-muted">{{ 'ErrorHandler.atLeastOneTemplate' | translate }}</span>
          } @if (hasDesynced) {
          <span class="blocking-hint">
            <i class="icofont icofont-warning-alt"></i>
            {{ 'ErrorHandler.syncRequired' | translate }}
          </span>
          }
          <button (click)="cancel()" class="btn btn-primary btn-sm btn-danger">
            {{ 'ErrorHandler.cancel' | translate }}
          </button>
          <button (click)="save()" [disabled]="saveDisabled" class="btn btn-primary btn-sm">
            {{ 'ErrorHandler.validate' | translate }}
          </button>
        </div>
      </div>
      <hr />
      <div [formGroup]="headerFormGroup" class="wrapper-header">
        <div class="left-header">
          <h5 class="titre">
            @if (!editTitle) { {{ customPagesProfileModel?.name }}
            <i (click)="editTitle = true" class="icofont icofont-pencil-alt-2 primary-color-pencil"></i>
            } @else {
            <input
              #nameInput
              (keyup.enter)="confirmTitle()"
              [placeholder]="customPagesProfileModel?.name || (('ErrorHandler.createProfile' | translate) +' #'+ customProfileSize)"
              formControlName="name"
              type="text"
            />
            <button (click)="confirmTitle()" class="btn btn-primary btn-sm">
              {{ 'ErrorHandler.validate' | translate }}
            </button>
            }
          </h5>

          <textarea
            [placeholder]="'ErrorHandler.comment' | translate"
            class="w-100 form-control ng-untouched ng-pristine ng-valid"
            formControlName="comment"
            rows="2"
            spellcheck="false"
          ></textarea>
        </div>
      </div>
    </div>
  </div>

  @for (card of cards; track trackByKey($index, card)) {
  <div [class.editing]="card.desynced" [class.invalid]="card.invalid" [formGroupName]="card.key" class="exception-card">
    <div class="exception-card-header">
      <div (click)="toggleExpand(card.key)" class="header-left">
        <span
          [attr.aria-expanded]="card.expanded"
          [attr.aria-label]="(card.expanded ? 'ErrorHandler.collapse' : 'ErrorHandler.expand') | translate"
          class="chevron"
          role="button"
        >
          <i
            [class.icofont-rounded-down]="card.expanded"
            [class.icofont-rounded-right]="!card.expanded"
            class="icofont"
          ></i>
        </span>
        <span class="error-label">{{ card.descriptionKey | translate }} {{ card.label }}</span>
        @if (card.invalid) {
        <span class="invalid-badge">
          <i class="icofont icofont-warning-alt"></i>
          {{ 'ErrorHandler.invalidContent' | translate }}
        </span>
        } @else if (card.desynced) {
        <span class="desync-badge">{{ 'ErrorHandler.notSynced' | translate }}</span>
        }
      </div>

      <div class="toggle-group">
        <button
          (click)="resetTemplate(card.key)"
          [attr.title]="'ErrorHandler.resetTemplate' | translate"
          [disabled]="card.resetDisabled"
          class="btn btn-primary btn-sm"
          type="button"
        >
          <i class="icofont icofont-refresh"></i>
          {{ 'ErrorHandler.reset' | translate }}
        </button>
        <app-switch formControlName="activate" />
      </div>
    </div>

    @if (card.expanded) {
    <div [class.disable-body]="!card.activated" [class.no-sync]="!card.needsSync" class="exception-card-body">
      @if (card.challenge) {
      <div class="exception-card-body-left-part">
        <div class="exception-card-body-content">
          <div class="left">
            <span class="title">{{ 'ErrorHandler.header' | translate }}</span>
          </div>
          <textarea
            (blur)="setChallengeFocus(null)"
            (focus)="setChallengeFocus('header')"
            [class.field-invalid]="card.fieldInvalidHeader"
            cols="30"
            formControlName="header"
            rows="5"
            spellcheck="false"
          ></textarea>
        </div>

        @if (card.unsafeHtmlHeader) {
        <span class="validation-hint">{{ 'ErrorHandler.unsafeHtml' | translate }}{{ card.unsafeHtmlHeader }}</span>
        } @if (card.byteSizeHeader; as size) {
        <span class="validation-hint"
          >{{ 'ErrorHandler.maxSizeExceeded' | translate }} ({{ size.actual }} / {{ size.max }} o)</span
        >
        }

        <div class="exception-card-body-content">
          <div class="left">
            <span class="title">{{ 'ErrorHandler.footer' | translate }}</span>
          </div>
          <textarea
            (blur)="setChallengeFocus(null)"
            (focus)="setChallengeFocus('footer')"
            [class.field-invalid]="card.fieldInvalidFooter"
            cols="30"
            formControlName="footer"
            rows="5"
            spellcheck="false"
          ></textarea>
        </div>

        @if (card.unsafeHtmlFooter) {
        <span class="validation-hint">{{ 'ErrorHandler.unsafeHtml' | translate }}{{ card.unsafeHtmlFooter }}</span>
        } @if (card.byteSizeFooter; as size) {
        <span class="validation-hint"
          >{{ 'ErrorHandler.maxSizeExceeded' | translate }} ({{ size.actual }} / {{ size.max }} o)</span
        >
        } @if (card.sanitized) {
        <span class="sanitize-hint">
          <i class="icofont icofont-info-circle"></i>
          {{ 'ErrorHandler.sanitizedByServer' | translate }} ({{ card.sanitizedLabel }})
        </span>
        }

        <div class="exception-card-body-type">
          <div class="left">
            <span class="title">{{ 'ErrorHandler.backgroundColor' | translate }}</span>
            <span class="description">{{ 'ErrorHandler.backgroundColorDescription' | translate }}</span>
          </div>
          <input formControlName="backgroundColor" type="color" />
        </div>
      </div>

      <div class="vertical-line">
        <div class="sync-control">
          <button
            (click)="sync(card.key)"
            [attr.title]="'ErrorHandler.update' | translate"
            [class.syncing]="card.syncing"
            [disabled]="card.syncDisabled"
            class="sync-btn"
            type="button"
          >
            <i [class.icofont-arrow-right]="!card.syncing" [class.icofont-spinner]="card.syncing" class="icofont"></i>
          </button>
          <span [class.muted]="card.syncDisabled" class="sync-caption">{{ 'ErrorHandler.update' | translate }}</span>
        </div>
      </div>

      <div class="preview">
        <span class="preview-title">{{ 'ErrorHandler.preview' | translate }}</span>
        <div [class.stale]="card.desynced" [style.background]="card.backgroundColor" class="challenge-preview">
          <div class="page-container">
            <div
              [class.focused-zone]="challengeFocus === 'header'"
              [innerHTML]="challengeHeader"
              class="page-header"
            ></div>

            <div class="container-challenge">
              <div class="challenge">
                <span class="challenge-tooltip">{{ 'ErrorHandler.verifyHuman' | translate }}</span>
                <input class="challenge-checkbox" tabindex="-1" type="checkbox" />
                <img alt="Logo" class="challenge-logo" src="assets/images/logo-blue.png" />
              </div>
            </div>

            <div
              [class.focused-zone]="challengeFocus === 'footer'"
              [innerHTML]="challengeFooter"
              class="page-footer"
            ></div>
          </div>
        </div>
      </div>
      } @else {
      <div class="exception-card-body-left-part">
        <div class="exception-card-body-type">
          <div class="left">
            <span class="title">{{ 'ErrorHandler.contentType' | translate }}</span>
            <span class="description">{{ 'ErrorHandler.contentTypeDescription' | translate }}</span>
          </div>
          <ng-select [closeOnSelect]="true" class="large-dropdown" formControlName="contentType">
            @for (option of contentTypeOptions; track trackByOption($index, option)) {
            <ng-option [value]="option.key">{{ option.label }}</ng-option>
            }
          </ng-select>
        </div>

        <div class="exception-card-body-content">
          <div class="left">
            <span class="title">{{ 'ErrorHandler.body' | translate }}</span>
          </div>
          <textarea
            [class.field-invalid]="card.fieldInvalidBody"
            [id]="'advancedConditionText-' + card.key"
            cols="30"
            formControlName="body"
            rows="5"
            spellcheck="false"
          ></textarea>
        </div>

        @if (card.unsafeHtmlBody) {
        <span class="validation-hint">{{ 'ErrorHandler.unsafeHtml' | translate }}{{ card.unsafeHtmlBody }}</span>
        } @if (card.byteSizeBody; as size) {
        <span class="validation-hint"
          >{{ 'ErrorHandler.maxSizeExceeded' | translate }} ({{ size.actual }} / {{ size.max }} o)</span
        >
        } @if (card.jsonError) {
        <span class="validation-hint">{{ 'ErrorHandler.invalidJson' | translate }}{{ card.jsonError }}</span>
        } @if (card.sanitized) {
        <span class="sanitize-hint">
          <i class="icofont icofont-info-circle"></i>
          {{ 'ErrorHandler.sanitizedByServer' | translate }}
        </span>
        }
      </div>

      @if (card.needsSync) {
      <div class="vertical-line">
        <div class="sync-control">
          <button
            (click)="sync(card.key)"
            [attr.title]="'ErrorHandler.update' | translate"
            [class.syncing]="card.syncing"
            [disabled]="card.syncDisabled"
            class="sync-btn"
            type="button"
          >
            <i [class.icofont-arrow-right]="!card.syncing" [class.icofont-spinner]="card.syncing" class="icofont"></i>
          </button>
          <span [class.muted]="card.syncDisabled" class="sync-caption">{{ 'ErrorHandler.update' | translate }}</span>
        </div>
      </div>
      } @else {
      <div class="vertical-line"></div>
      }

      <div class="preview">
        <span class="preview-title">{{ 'ErrorHandler.preview' | translate }}</span>

        @switch (card.previewType) { @case ('HTML') {
        <iframe [class.stale]="card.desynced" [srcdoc]="card.previewHtml" class="preview-frame" sandbox=""></iframe>
        } @case ('JSON') {
        <div [class.stale]="card.desynced" class="preview-json">{{ card.previewText }}</div>
        } @default {
        <div [class.stale]="card.desynced" class="preview-plain">{{ card.previewText }}</div>
        } }
      </div>
      }
    </div>
    }
  </div>
  }
</div>
